// import _ from "lodash";
// import { BLOCK_TYPES } from "../../common/index";
// const { V2_STORIES_BLOCK } = BLOCK_TYPES;
import React from "react";

const renderSettings: React.FC<any> = ({ block }: any) => {
    // const {
    //     id,
    //     tmpId,
    //     data: {
    //         [blockType]: { title },
    //     },
    //     children,
    // } = block;

    return <div></div>;
};

export default renderSettings;
